export const videoQuestions = [
    {
        id: 123,
        // conceptName: 'Newton\'s second law of motion',
        timeInVideo: 10,
        // conceptRefersTo: 110,
        question: 'Sense child do state to defer mr of forty. Become latter but nor abroad wis?',
        tag: 'Text'
    },
    {
        id: 987123,
        // conceptName: 'Newton\'s second law of motion',
        timeInVideo: 13,
        // conceptRefersTo: 110,
        question: 'More preparatory much derisively far impulsively opposite whi?',
        tag: 'MCQ'
    },
    {
        id: 222123,
        // conceptName: 'Newton\'s second law of motion',
        timeInVideo: 40,
        // conceptRefersTo: 110,
        question: 'Over fact all son tell this any his. No insisted confined of weddings to ret?',
        tag: 'MCQ'
    },
];



// WEBPACK FOOTER //
// ./src/data/EditChapterPart/videoQuestions.js